import { useDroppable } from '@dnd-kit/core';
import React from 'react';
import DashboardComponent from './DashboardComponent';

const BaseDashboardPanel = ({ id, position, color, children, locked, activeId, overId, onClick, onRemoveClick, onEditClick }) => {
    const { setNodeRef } = useDroppable({ id });

    const handleClick = () => {
        if (onClick && typeof onClick === 'function') {
            onClick();
        }
    };

    return (
        <div
            ref={setNodeRef}
            onClick={handleClick}
            style={{
                position: "absolute",
                top: position.top,
                left: position.left,
                width: "49%",
                height: "49%",
                backgroundColor:
                    activeId === id
                        ? 'red'
                        : overId === id
                            ? 'lightgreen'
                            : 'white',
            }}
        >
            <DashboardComponent
                id={id}
                color={color}
                locked={locked}
                onRemove={() => {
                    if (onRemoveClick) {
                        onRemoveClick();
                    }
                }}
                onEdit={() => {
                    if (onEditClick) {
                        onEditClick();
                    }
                }}
            >
                {children}
            </DashboardComponent>
        </div>
    );
};
export default BaseDashboardPanel;
